import React, { useState } from 'react';
import { format } from 'date-fns';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Alert,
  Typography,
  Autocomplete,
} from '@mui/material';
import { auth, db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

const AddPastExpense = ({ open, onClose, userFamily, categories }) => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [selectedDate, setSelectedDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    try {
      const user = auth.currentUser;
      if (!user) {
        setError('Utente non autenticato');
        return;
      }

      if (!amount || !description || !category || !selectedDate) {
        setError('Tutti i campi sono obbligatori');
        return;
      }

      const numericAmount = parseFloat(amount.replace(',', '.'));
      if (isNaN(numericAmount) || numericAmount <= 0) {
        setError("L'importo deve essere un numero positivo");
        return;
      }

      const expenseData = {
        amount: numericAmount,
        name: description.trim(),
        category: category.trim(),
        date: new Date(selectedDate),
        userId: user.uid,
        familyId: userFamily?.id || null,
        createdAt: new Date(),
        isComplete: false,
      };

      await addDoc(collection(db, 'expenses'), expenseData);

      setAmount('');
      setDescription('');
      setCategory('');
      setSelectedDate(format(new Date(), 'yyyy-MM-dd'));
      setSuccess(true);

      setTimeout(() => {
        onClose();
        setSuccess(false);
      }, 1500);

    } catch (err) {
      console.error('Errore durante l\'aggiunta della spesa:', err);
      setError('Si è verificato un errore durante il salvataggio della spesa');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Aggiungi Spesa Passata
        <Typography variant="subtitle2" color="text.secondary">
          Inserisci una spesa per una data specifica
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Spesa aggiunta con successo!
            </Alert>
          )}

          {/* Campo data senza etichetta */}
          <TextField
            fullWidth
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            margin="normal"
            inputProps={{
              max: format(new Date(), 'yyyy-MM-dd'), // Limita la selezione a oggi
            }}
          />

          <TextField
            fullWidth
            label="Importo (€)"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            margin="normal"
            type="text"
            inputProps={{ inputMode: 'decimal' }}
          />

          <TextField
            fullWidth
            label="Descrizione"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            margin="normal"
          />

          <Autocomplete
            freeSolo
            options={categories || []}
            value={category}
            onChange={(event, newValue) => setCategory(newValue)}
            onInputChange={(event, newInputValue) => setCategory(newInputValue)}
            renderInput={(params) => (
              <TextField {...params} label="Categoria" variant="outlined" margin="normal" />
            )}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annulla</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Aggiungi Spesa
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPastExpense;
